globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.OptIn = (function() {
    function OptIn() {}

    OptIn.init = function() {
      $('body').on('click', '.open-opt-in-subjects-popup', function() {
        var $this = $(this),
            url = $this.data('ajax-url');

        if(url) {
          $.get(url, function(data) {
            if(data.response && data.html) {
              var $html = $(data.html),
                  popup = new appVisitor.Popup({});

              $html.data('element', $this.closest('.element'));
              popup.$html = $html;
              popup.render();
            }
          }).fail(function() {});
        }

        return false;
      }).on('click', '.popup-cover.opt-in-subjects button[type=submit]', function() {
        var $popup = $(this).closest('.opt-in-subjects'),
            $element = $popup.data('element');

        if($element) {
          var $elementOptInSubjectInputs = $element.find('input[name*=opt_in_subject_ids]');

          $popup.find('input[type=checkbox]:checked').each(function() {
            var $this = $(this);

            $elementOptInSubjectInputs.filter(function() { return $(this).val() == $this.val() }).prop('disabled', false);
          });

          $popup.fadeOut('fast', function() {
            $popup.remove();
            $element.find('form').submit();
            $elementOptInSubjectInputs.prop('disabled', true);
          });
        }
      });
    }

    return OptIn;
})();
